import { render, staticRenderFns } from "./IconEmailMessage.vue?vue&type=template&id=22ff9606"
import script from "./IconEmailMessage.vue?vue&type=script&lang=js"
export * from "./IconEmailMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports